import { INoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin.interface';
import type { UserInfo } from '@tencent/docs-login/dist/utils/user';

// 登录plugin名称
export const LOGIN_PLUGIN_NAME = 'no-edit-login';

export interface ILoginPlugin extends INoEditPlugin {
    userInfo: UserInfo | undefined;
    /**
     * 是否是登录态
     */
    isLogin(): boolean;

    /**
     * 触发登录动作
     */
    login(): Promise<void>;

    /**
     * 注销
     */
    logout(): void;

    getUid(): string;
    getUidKey(): string;

    /**
     * 获取缓存的用户信息，异步方式
     */
    getUserInfo(): Promise<UserInfo | undefined>;

    /**
     * 拉取用户信息结束回调
     * @param callback
     */
    onUserReady(callback: (data: any) => void);
}
